// extracted by mini-css-extract-plugin
module.exports = {"background":"Login_background__2yI12","logo":"Login_logo__15hBy","contentWrap":"Login_contentWrap__YdBy9","box":"Login_box__FA8qd"};